<template>
  <div class="conversation-hub-container">
    <div class="tab-buttons">
      <button :class="{ active: !isConversationsTab }" @click="setActiveTab(tabs.INFORMATION)">
        {{ infoTitle }}
      </button>
      <button :class="{ active: isConversationsTab }" @click="setActiveTab(tabs.CONVERSATIONS)">
        {{ conversationsTitle }}
      </button>
    </div>
    <!-- Tab Conversation -->
    <div v-if="isConversationsTab" class="conversations-list">
      <div v-if="conversations.length === 0" class="no-conversations">
        <h3>{{ $t('conversation_hub.no_conversations') }}</h3>
      </div>
      <div v-else>
        <ConversationCard
          v-for="(conv, idx) in conversations"
          :key="idx"
          :conversation="conv"
          :index="idx"
          :avatar="avatar"
          :assistant-title="assistantTitle"
          @click="$emit('conversation-click', conv)"
        />
      </div>
    </div>
    <!-- Tab Information -->
    <div v-else class="info-tab">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="sanitizedContent" v-html="sanitizedContent"></div>
    </div>
    <div class="resume-btn-container">
      <button class="resume-btn" @click="$emit('resume-conversation')">
        {{ $t('conversation_hub.resume_conversation_button') }}
      </button>
    </div>
  </div>
</template>

<script>
// Components
import ConversationCard from './ConversationCard.vue'

// Style
import '../../assets/styles/conversationHub.css'

// Config
import config from '../../config/conversationHub.js'

// Dependencies
import { mapGetters } from 'vuex'

export default {
  name: 'ConversationHub',
  components: { ConversationCard },
  props: {
    conversationHub: {
      type: Object,
      default: () => ({})
    },
    avatar: {
      type: String,
      required: true
    },
    assistantTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeTab: config.TABS.INFORMATION,
      tabs: config.TABS
    }
  },
  computed: {
    ...mapGetters(['conversations', 'selectedHubTab']),
    hubInformation() {
      return (this.conversationHub && this.conversationHub.information) || {}
    },
    hubConversationHistory() {
      return (this.conversationHub && this.conversationHub.conversationHistory) || {}
    },
    infoTitle() {
      return this.hubInformation.menuTitle || this.$t('conversation_hub.info_title')
    },
    conversationsTitle() {
      return this.hubConversationHistory.menuTitle || this.$t('conversation_hub.conversations_title')
    },
    sanitizedContent() {
      if (this.hubInformation.htmlContent) {
        return this.$sanitize(this.hubInformation.htmlContent)
      }
      return null
    },
    isConversationsTab() {
      return this.activeTab === config.TABS.CONVERSATIONS
    }
  },
  mounted() {
    this.activeTab = this.selectedHubTab
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
      this.$store.dispatch('set_selected_hub_tab', tab)
    }
  }
}
</script>
